(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', Shopify.gtmId);

document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
const myTooltip = (origin) => {
  const tooltipWrap = origin.closest('.js-tooltip-wrap');
  const tooltipObject = tooltipWrap.querySelector('.js-tooltip-object');
  tooltipObject.classList.toggle('is-open');
};

document.addEventListener('DOMContentLoaded', () => {
  const tooltipClass = document.getElementsByClassName('js-tooltip');
  const tooltipClose = document.getElementsByClassName('arrow_box__content__close');

  for (const trigger of tooltipClass) {
    trigger.addEventListener('click', () => {
      myTooltip(trigger);
    });
  }

  for (const btn of tooltipClose) {
    btn.addEventListener('click', (e) => {
      const thisTooltip = btn.closest('.js-tooltip-wrap').querySelector('.js-tooltip');
      myTooltip(thisTooltip);
    });
  }
});

$(window).on('load', () => {
  setGaTitle();

  // slick は v1 レイアウト(theme.liquid/v1-theme.liquid)のみでロードされる。v2 は Lit
  // スライダー(v2-product-image-slider)を使うため .product__slider__main が存在せず、
  // slick も v2-theme.liquid から除去済み(Tier 2-2f)。theme.js は v1/v2 共有のため、
  // プラグイン/要素の不在時は早期 return して v2 での `$(...).slick is not a function` を防ぐ。
  if (!$.fn.slick || !$('.product__slider__main').length) {
    return;
  }

  var hasThumbSlider = $('.product__slider__thumbs').length > 0;

  $('.product__slider__main').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !hasThumbSlider,
    fade: true,
    prevArrow: '<p class="slick-prev"></p>',
    nextArrow: '<p class="slick-next"></p>',
    asNavFor: hasThumbSlider ? '.product__slider__thumbs' : undefined,
  });

  if (hasThumbSlider) {
    $('.product__slider__thumbs').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product__slider__main',
      focusOnSelect: true,
      arrows: true,
      prevArrow: '<p class="slick-prev"></p>',
      nextArrow: '<p class="slick-next"></p>',
      infinite: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 4,
          },
        },
      ],
    });
  }
});

// CLS対策で非表示にしていたMVスライダーを再表示させる
const mvWrapper = document.querySelector("ul[class='mv-wrapper swiper-wrapper']");
if (mvWrapper) {
  mvWrapper.childNodes.forEach((node) => {
    if (node.tagName && node.tagName === 'LI') {
      node.style.display = 'list-item';
    }
  });
}
// eslint-disable-next-line no-unused-vars
var mySwiper = new Swiper('.mv-container', {
  slidesPerView: 1.2,
  centeredSlides: true,
  loop: true,
  spaceBetween: 8,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  lazy: {
    loadPrevNext: true,
  },
  breakpoints: {
    750: {
      spaceBetween: 30,
      slidesPerView: 2.5,
    },
  },
});

function setGaTitle() {
  $('.ga-product_title').each(function (i) {
    let textTitle = $(this).text();
    if (textTitle.length > 30) {
      textTitle = `${textTitle.substring(0, 30)}...`;
    }
    $(this).text(textTitle);
  });
}

$(document).ready(function () {
  const pathUrl = window.location.href;
  const rdValue = localStorage.getItem('rdValue');
  let $returnTo = $('<input type="hidden" name="return_to" value="/account" />');

  if (rdValue) {
    $returnTo = $('<input type="hidden" name="return_to" value="' + rdValue + '" />');
  }

  if ($('#customer_login').length) {
    $returnTo.insertBefore($('#customer_login button'));
  } else if ($('#g-recaptcha').length) {
    $returnTo.insertBefore($('.shopify-challenge__container input[type="submit"]'));
  } else {
    localStorage.setItem('rdValue', pathUrl);
  }
});

const currentUrl = window.location.href;
if (currentUrl.includes('/products/list?')) {
  const params = getUrlVars();
  window.location.replace('/search?q=' + params.name + '&options%5Bprefix%5D=last');
}

function getUrlVars() {
  const vars = {};
  const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars;
}

if (typeof premiumCustomerDuplicateTheme !== 'undefined' && premiumCustomerDuplicateTheme) {
  $('.duplicate-premium-error').detach().appendTo('body');
  $('.duplicate-premium-error').css('display', 'flex');
  didntCheckout = true;
}

$('.duplicate-premium-error .accept-button').click(function (e) {
  $.post('/cart/clear.js', null, null, 'json')
    .then((res) => location.reload())
    .catch((err) => {});
});

if (GetURLParameter('utm_source') || GetURLParameter('utm_medium') || GetURLParameter('utm_campaign')) {
  const currentTime = new Date();
  const UTMEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth() + 1, 1);
  localStorage.setItem(
    'UTMParams',
    JSON.stringify({
      timeEnd: UTMEndTime.getTime(),
      utm_source: GetURLParameter('utm_source'),
      utm_medium: GetURLParameter('utm_medium'),
      utm_campaign: GetURLParameter('utm_campaign'),
    }),
  );
}

function GetURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1];
    }
  }
}

window.addEventListener('unhandledrejection', (event) => {
  // eslint-disable-next-line no-console
  console.error('Unhandled rejection (promise: ', event.promise, ', reason: ', event.reason, ').');
});

(function () {
  // 画像の読み込みエラー時にSentryに通知
  if (Shopify.useImageErrorTracking && 'MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        Array.from(mutation.addedNodes)
          .filter((node) => ['IMG', 'SOURCE'].indexOf(node.tagName) !== -1)
          .forEach((resource) => {
            resource.onerror = function () {
              const targetElement = this;
              const attr = targetElement.getAttribute('src') || targetElement.getAttribute('srcset');
              // 相対パスの場合は絶対パスに変換
              const targetURL = new URL(attr, window.location.href);
              if (targetURL.host != 'cdn.shopify.com' && targetURL.host != 'kuradashi.jp') {
                return;
              }

              function waitForSentry(msg) {
                const interval = 10; // ms

                setTimeout(function () {
                  if (window['Sentry']) {
                    Sentry.captureMessage(msg);
                  } else {
                    waitForSentry(msg);
                  }
                }, interval);
              }
              waitForSentry('Failed loading resource: ' + attr + ' for tag: ' + this.tagName);
            };
          });
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();

(function () {
  function isLocalStorageAvailable() {
    var test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }
  function setValue(flagName, storedValue) {
    if (isLocalStorageAvailable()) {
      // LocalStorageが利用可能な場合
      localStorage.setItem(flagName, storedValue);
    } else {
      // LocalStorageが利用できない場合はCookieを使用
      document.cookie = flagName + '=' + storedValue + '; path=/';
    }
  }
  function getValue(valueKey) {
    if (isLocalStorageAvailable()) {
      // LocalStorageが利用可能な場合
      return localStorage.getItem(valueKey);
    }
    // LocalStorageが利用できない場合はCookieを使用
    var name = valueKey + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  const utmSource = GetURLParameter('utm_source');  
  if (utmSource === 'kuradashi_app') {  
    const customerId = typeof Shopify === 'object' && Shopify.customer?.id ? Shopify.customer.id : '';  
      
    if (customerId) {  
      const isSent = getValue('yappli_sent');  
      if (isSent !== 'true') {  
        Yappli.setMemberId(customerId);  
        setValue('yappli_sent', 'true');  
      }  
    }  
  }
})();

function sendYappliEvent(eventName, value) {
  // アプリからしかYappliへ送信しない
  // UAがYappliを含む場合は送信する
  if (navigator.userAgent.includes('Yappli')) {
    Yappli.sendTrackedEvent(eventName, value, function (result) {
      if (!result) {
        sendYappliEvent(eventName, value);
      }
    });
  }
}

function changeHeight(element, lineCount) {
  const targetElementStyle = window.getComputedStyle(element);
  const lineHeight = parseInt(targetElementStyle.lineHeight, 10);
  const height = lineHeight * lineCount;
  // 高さが期待値と個なる場合のみ高さを変更
  if (element.scrollHeight != height) {
    element.style.height = height + 'px';
  } else {
    element.style.height = 'auto';
  }
}

function updateClamp() {
  const rankingTitleElement = document.querySelectorAll('.ranking-section__title');
  const windowWidth = window.innerWidth;
  const MAX_LINE = windowWidth >= 750 ? 2 : 3;
  rankingTitleElement.forEach((element) => {
    if (windowWidth >= 750) {
      changeHeight(element, MAX_LINE);
    } else {
      changeHeight(element, MAX_LINE);
    }
  });
}
// ドキュメントのロード後に実行
document.addEventListener('DOMContentLoaded', updateClamp);

// 画面幅を変えて使うことは基本ないはずだが、念のため対応する。
(function () {
  const minWidth750pxMediaQuery = window.matchMedia('(min-width: 750px)');
  if (typeof minWidth750pxMediaQuery.addEventListener === 'function') {
    minWidth750pxMediaQuery.addEventListener('change', () => {
      // setTimeoutはCSSの切り替えが終わらないと高さが更新されないため
      setTimeout(() => {
        updateClamp();
      }, 300);
    });
  }
})();

(function () {
  if (typeof Shopify === 'undefined') {
    return;
  }
  // deleted_accountのCookeがtrueの場合はリダイレクトはおこなわない
  const enableDeletedAccountCookie = document.cookie.split('; ').includes('deleted_account=true');
  if (Shopify.deletedAccount && !enableDeletedAccountCookie) {
    // cookieに deleted_account=trueをセットしてhttps://help.kuradashi.jp/ja/articles/fd3436e9
    document.cookie = 'deleted_account=true; path=/';
    window.location.href = 'https://help.kuradashi.jp/ja/articles/fd3436e9';
  } else if (!Shopify.deletedAccount && enableDeletedAccountCookie) {
    // deleted_accountのCookieがある場合は削除する
    document.cookie = 'deleted_account=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
})();
